import { Tooltip } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getColors as fetchColors } from '@store/design/action';
import { getAllColors } from '@store/reducers';

const AddColor = ({ onCloseColor, selectedColors = [], onSubmitColor }) => {
	const [searchTerm, setSearchTerm] = useState('');
	const [selectedColorList, setSelectedColorList] = useState([]);
	let colors = useSelector(getAllColors);
	colors = colors.map((item) => {
		return {
			...item,
			pantoneColorId: item.id
		};
	});
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(fetchColors(searchTerm, 200));
	}, [searchTerm]);

	const getFilteredColors = () => {
		let selectedColorLists = [...selectedColorList, ...selectedColors];
		return colors.filter(
			(o1) => !selectedColorLists.some((o2) => o1.pantoneColorId === o2?.pantoneColorId)
		);
	};

	const onColorClicks = (item) => {
		onSubmitColor(item);
		setSelectedColorList([...selectedColorList, item]);
	};

	// const onRemoveColor = (item) => {
	// 	setSelectedColorList([...selectedColorList.filter((color) => color.id !== item.id)]);
	// };

	const onSearchColor = (e) => {
		let value = e.target.value;
		setSearchTerm(value);
	};

	return (
		<div className="common-color-popup">
			<div className="color-popup-header">
				<h5>Add color</h5>
				<span className="cursor-pointer" onClick={() => onCloseColor()}>
					<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} />
				</span>
			</div>
			<div className="common-color-popup-body">
				<div className="search-color">
					<div className="search-by-name">
						<input
							type="text"
							autoComplete="off"
							className="form-field"
							placeholder="Search Color"
							onChange={onSearchColor}
						/>
						<span>
							<img src={`${process.env.PUBLIC_URL}/icons/search.png`} />
						</span>
					</div>
				</div>
				<div className="all-available-colors scroll-y-label">
					<p>Search Result</p>
					<div className="common-color-list">
						{getFilteredColors()?.map((item) => (
							<Tooltip
								title={
									<>
										<h5 className="font-12">{item?.code}</h5>
										<span>{item.name}</span>
									</>
								}
								placement="top"
								arrow
								className="cursor-pointer"
								key={`color_code_${item.code}`}
							>
								<span
									key={item.id}
									className="color-item"
									style={{
										background: item.hexCode
									}}
									onClick={() => onColorClicks(item)}
								/>
							</Tooltip>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddColor;
